import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from "antd";
import { Button } from "../../common/HtmlTags/Button/Button";
import { Container } from "../../common/HtmlTags/Container/Container";
import { Heading } from "../../common/HtmlTags/Heading/Heading";
import { Paragraph } from "../../common/HtmlTags/Paragraph/Paragraph";
import { AUTH_PROMPT_STRINGS } from "../../../constants/authPromptStrings";
import { savePendingDeepLink } from "../../../utils/deepLink";
import "./SignInToContinueModal.css";

export type SignInToContinueModalProps = {
  visible: boolean;
  onClose: () => void;
};

export default function SignInToContinueModal({
  visible,
  onClose,
}: SignInToContinueModalProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const preserveReturnPath = () => {
    const returnPath = `${location.pathname}${location.search}`;
    if (returnPath && returnPath !== "/") {
      savePendingDeepLink(returnPath);
    }
  };

  const handleSignIn = () => {
    preserveReturnPath();
    onClose();
    const returnPath = `${location.pathname}${location.search}`;
    const redirect =
      returnPath && returnPath !== "/"
        ? `?redirect=${encodeURIComponent(returnPath)}`
        : "";
    navigate(`/auth/login${redirect}`);
  };

  const handleSignUp = () => {
    preserveReturnPath();
    onClose();
    const returnPath = `${location.pathname}${location.search}`;
    const redirect =
      returnPath && returnPath !== "/"
        ? `?redirect=${encodeURIComponent(returnPath)}`
        : "";
    navigate(`/auth/signup${redirect}`);
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnHidden
      className="sign-in-to-continue-modal"
      data-testid="sign-in-to-continue-modal"
    >
      <Heading variant="h3" className="sign-in-to-continue-title">
        {AUTH_PROMPT_STRINGS.TITLE}
      </Heading>
      <Paragraph className="sign-in-to-continue-message">
        {AUTH_PROMPT_STRINGS.MESSAGE}
      </Paragraph>
      <Container className="sign-in-to-continue-actions">
        <Button
          palette="primary"
          size="medium"
          colorScheme="dark"
          hasIcon={false}
          onClick={handleSignIn}
        >
          {AUTH_PROMPT_STRINGS.SIGN_IN}
        </Button>
        <Button
          palette="secondary"
          size="medium"
          colorScheme="dark"
          hasIcon={false}
          onClick={handleSignUp}
        >
          {AUTH_PROMPT_STRINGS.SIGN_UP}
        </Button>
        <Button
          palette="accent"
          size="medium"
          colorScheme="medium"
          hasIcon={false}
          onClick={onClose}
        >
          {AUTH_PROMPT_STRINGS.DISMISS}
        </Button>
      </Container>
    </Modal>
  );
}
